module.exports = __webpack_public_path__ + "img/menu_icon10.9a323e8c.png";